var cilArrowThickFromLeft = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M296.007,56H257.375V176h-144V336h144V456H296L496,256.2Zm-6.632,361.384V304h-144V208h144V94.639l161.37,161.535Z' class='ci-primary'/><rect width='32' height='400' x='17.375' y='56' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/>"];

export { cilArrowThickFromLeft };

